(function () {
    'use strict';
    var controllerId = 'cndPartModuloAdd';
    angular.module('app').controller(controllerId, ['$scope', 'datacontext', '$uibModalInstance', 'partModulo', 'partecipazioneId', 'province', 'provinciaId', 'tIndirizzi', 'tRuoloCode', 'showIES', 'onlyRead', 'isSuper', fn_cndPartModuloAdd]);

    function fn_cndPartModuloAdd($scope, datacontext, $uibModalInstance, partModulo, partecipazioneId, province, provinciaId, tIndirizzi, tRuoloCode, showIES, onlyRead, isSuper) {
        $scope.province = province;
        $scope.comuni = [];
        $scope.tIndirizzi = tIndirizzi;
        $scope.change_Comuni = change_Comuni;

        $scope.onlyRead = onlyRead;
        console.info('onlyRead', onlyRead);
        $scope.showIES = showIES;
        $scope.isSuper = isSuper;

        $scope.cmblist = {};

        $scope.tModuli = [
            { Code: 'IES', Name: 'Igiene e sicurezza sul luogo di lavoro', Show: $scope.showIES }
            , { Code: 'CDT', Name: 'Competenze digitali trasversali', Show: true }
        ];

        $scope.change_tModulo = change_tModulo;
        $scope.change_competenza = change_competenza;
        $scope.modAb = false;
        $scope.modCon = false;

        if (partModulo) {
            $scope.title = 'Modifica Modulo Formativo';
            $scope.record = jQuery.extend({}, partModulo); //Clona oggetto
            console.info('$scope.record', $scope.record);
            change_competenza(0);
            $scope.modAb = true;
            $scope.modCon = true;
        }
        else {
            $scope.title = 'Nuovo Modulo Formativo';
            $scope.record = {};
            $scope.record.Id = 0;
            $scope.record.CodeFigura = '';
            if (!$scope.showIES) {
                $scope.record.CodeFigura = 'CDT';
                change_tModulo();
            }
        }

        if (tRuoloCode) {
            $scope.tRuoloCode = tRuoloCode;
            $scope.record.TRuoloCode = $scope.tRuoloCode;
            switch (tRuoloCode) {
                case 'AZD_FORM-LAV1':
                    $scope.modAb = true;
                    $scope.modCon = true;
                    $scope.record.CodeFigura = 'LAV1';
                    if ($scope.record.Id == 0) {
                        $scope.record.TIndirizzoId = 1;
                        $scope.record.ComuneId = '';
                    }
                    if ($scope.record.ProvinciaId > 0) {
                        getComuni($scope.record.ProvinciaId);
                    }
                    break;
                case 'AZD_FORM-FAM1':
                    $scope.record.TIndirizzoId = 0;
                    $scope.record.ComuneId = 0;
                    break;
            }
        }

        if (provinciaId != null) {
            $scope.record.ProvinciaId = provinciaId;
            change_Comuni(provinciaId);
        }

        if (partecipazioneId) {
            $scope.partecipazioneId = partecipazioneId;
            $scope.record.PartecipazioneId = partecipazioneId;
        }

        //Impostazioni per calendario dateTimePicker
        $scope.datepickers = {};
        $scope.today = function () {
            $scope.dt = new Date();
        };
        $scope.today();

        $scope.clear = function () {
            $scope.dt = null;
        };

        // Disable weekend selection
        $scope.disabled = function (date, mode) {
            return (mode === 'day' && (date.getDay() === 0 || date.getDay() === 6));
        };

        $scope.toggleMin = function () {
            $scope.minDate = $scope.minDate ? null : new Date();
        };
        $scope.toggleMin();
        $scope.dateOptions = {
            formatYear: 'yyyy',
            formatMonth: 'MM',
            startingDay: 1
        };

        $scope.open = function ($event, iOpened) {
            $event.preventDefault();
            $event.stopPropagation();

            $scope.opened1 = false;
            $scope.opened2 = false;
            if (iOpened == 1)
                $scope.opened1 = true;
            if (iOpened == 2)
                $scope.opened2 = true;

        };

        $scope.clear = function ($event, iOpened) {
            if (iOpened == 1) {
                //$scope.record.DDG_Dt = '';
                $scope.changed = true;
            }
            if (iOpened == 2) {
                //$scope.record.Autor_Dt = '';
                $scope.changed = true;
            }
        };

        $scope.format = "dd/MM/yyyy";

        $scope.ok = function (isValid) {
            if (isValid) {
                console.info('$scope.ok', $scope.record);
                if ($scope.record.Id == 0) {
                    var result = addItem($scope.record);
                    $uibModalInstance.close(result);
                }
                else {
                    var result1 = updateItem($scope.record);
                    $uibModalInstance.close(result1);
                }
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        function addItem(item) {
            return datacontext.partecipazioneModulo_add(item).then(function (data) {
                return data;
            });
        }

        function updateItem(item) {
            return datacontext.partecipazioneModulo_merge(item).then(function (data) {
                return data;
            });
        }

        function change_Comuni(idprov) {
            $scope.record.ComuneId = '';
            getComuni(idprov);
        };

        function getComuni(idprov) {
            if (!idprov || idprov == 0) return $scope.comuni = [];

            if ($scope.record.ProvinciaId != idprov)
                $scope.comuni = [];

            return datacontext.istat_comune_getAllList(idprov).then(function (data) {
                return $scope.comuni = data;
            });
        }

        function change_tModulo() {
            console.info('$scope.change_tModulo', $scope.record.CodeFigura);
            resetFields(1);
            getCompetenze($scope.record.CodeFigura);
            if ($scope.record.CodeFigura == 'IES') {
                $scope.record.NomeModulo = 'Igiene e sicurezza sul luogo di lavoro';
                $scope.record.Ore = 16;
                $scope.modAb = true;
                $scope.modCon = true;
            } else {
                $scope.record.NomeModulo = '';
                $scope.record.Ore = '';
                $scope.modAb = false;
                $scope.modCon = false;
            }
        };

        function getComp(id) {
            //console.info('getComp', id);
            $scope.record.CodeFigura = '';
            return datacontext.cndModCompetenza_get(id).then(function (data) {
                //console.info('data', data);
                if (data) {
                    $scope.record.CodeFigura = data.CodiceFigura;
                    if (data.CodiceFigura == 'IES') {
                        $scope.tModuli = [
                            { Code: 'IES', Name: 'Igiene e sicurezza sul luogo di lavoro', Show: true }
                            , { Code: 'CDT', Name: 'Competenze digitali trasversali', Show: true }
                        ];
                    }
                }
                return true;
            });
        }

        function getCompetenze(code) {
            console.info('getCompetenze', code);
            $scope.cmblist.competenze = [];
            return datacontext.cndModCompetenza_getAll(code).then(function (data) {
                if (data) {
                    if (data.length == 1) {
                        $scope.record.CompetenzaId = data[0].Id;
                    }
                }
                return $scope.cmblist.competenze = data;
            });
        }

        $scope.entities1 = [];
        $scope.entities2 = [];

        function change_competenza(index) {
            console.info('change_competenza', index);
            var code = '';
            resetFields(index);            
            if ($scope.record.CompetenzaId > 0) {  
                getComp($scope.record.CompetenzaId).then(function () {
                    //$scope.record.CodeFigura = $scope.record.CompetenzaId == 8 ? 'IES' : 'CDT';

                    return getCompetenze($scope.record.CodeFigura).then(function () {

                        var comp = _.find($scope.cmblist.competenze, function (o) { return o.Id == $scope.record.CompetenzaId; });
                        console.info('competenza', comp);
                        if (comp != null) {
                            code = comp.Codice;

                            if (comp.Id != 8) {
                                $scope.record.Competenze = comp.Titolo;
                            }
                        }

                        getCNDAbilita(code).then(function () {
                            checkEntities(index, 'abilita');
                        });
                        getCNDConoscenza(code).then(function () {
                            checkEntities(index, 'conoscenze');
                        });

                    });
                });
            }
        }

        function resetFields(index) {
            if (index == 1) {
                $scope.record.Competenze = '';
                $scope.record.Abilita = '';
                $scope.record.AbilitaCodes = '';
                $scope.record.Conoscenze = '';
                $scope.record.ConoscenzaCodes = '';
                $scope.entities1 = [];
                $scope.entities2 = [];
                $scope.modAb = false;
                $scope.modCon = false;
            }
        }

        function getCNDAbilita(code) {
            $scope.entities1 = [];
            if (!code) return;
            return datacontext.cndModAbilita_getAll(code).then(function (data) {
                return $scope.entities1 = data;
            });
        }

        $scope.click_abilita = function () {
            $scope.record.Abilita = '';
            $scope.record.AbilitaCodes = '';
            $scope.modAb = false;
            $("input:checkbox[name=list1Id]:checked").each(function () {
                $scope.modAb = true;
                var id = $(this).val();
                var entity = _.find($scope.entities1, function (o) { return o.Id == id; });
                if (entity != null) {
                    $scope.record.Abilita += entity.Titolo + ';\n';
                    $scope.record.AbilitaCodes += entity.Codice + ';';
                }
            });
        };

        function getCNDConoscenza(code) {
            $scope.entities2 = [];
            if (!code) return;
            return datacontext.cndModConoscenza_getAll(code).then(function (data) {
                return $scope.entities2 = data;
            });
        }

        $scope.click_conoscenza = function () {
            $scope.record.Conoscenze = '';
            $scope.record.ConoscenzaCodes = '';
            $scope.modCon = false;
            $("input:checkbox[name=list2Id]:checked").each(function () {
                $scope.modCon = true;
                var id = $(this).val();
                var entity = _.find($scope.entities2, function (o) { return o.Id == id; });
                if (entity != null) {
                    $scope.record.Conoscenze += entity.Titolo + ';\n';
                    $scope.record.ConoscenzaCodes += entity.Codice + ';';
                }
            });
        };

        $scope.checkAll = function (index) {
            switch (index) {
                case 1: //Abilita
                    if ($scope.selectedAll1) {
                        $scope.selectedAll1 = true;
                    } else {
                        $scope.selectedAll1 = false;
                    }
                    $scope.click_abilita();
                    break;
                case 2: //Conoscenze
                    if ($scope.selectedAll2) {
                        $scope.selectedAll2 = true;
                    } else {
                        $scope.selectedAll2 = false;
                    }
                    $scope.click_conoscenza();
                    break;
            }
        };

        function checkEntities(index, code) {
            if (index == 0) {
                switch (code) {
                    case 'abilita':
                        if ($scope.record.AbilitaCodes && $scope.record.AbilitaCodes.length > 0) {
                            var listAbilita = $scope.record.AbilitaCodes.split(';');
                            listAbilita.forEach(function (lCode) {
                                //console.info('lCode', lCode);
                                $.each($scope.entities1, function (i, entity) {
                                    if (entity != null && lCode != null && entity.Codice == lCode) {
                                        var checkbox = $("input[type=checkbox][id=#opt1_" + entity.Id.toString() + "]");
                                        checkbox.checked = true;
                                        entity.checked = true;
                                        //console.info('checkbox1', checkbox);
                                    }
                                });
                            });
                        }
                        break;
                    case 'conoscenze':
                        if ($scope.record.ConoscenzaCodes && $scope.record.ConoscenzaCodes.length > 0) {
                            var listConoscenza = $scope.record.ConoscenzaCodes.split(';');
                            listConoscenza.forEach(function (lCode) {
                                //console.info('lCode', lCode);
                                $.each($scope.entities2, function (i, entity) {
                                    if (entity != null && lCode != null && entity.Codice == lCode) {
                                        var checkbox = $("input[type=checkbox][id=#opt2_" + entity.Id.toString() + "]");
                                        checkbox.checked = true;
                                        entity.checked = true;
                                        //console.info('checkbox2', checkbox);
                                    }
                                });
                            });
                        }
                        break;
                }
            }
            
        }

    }
})();